import { useQuery } from "@tanstack/react-query";
import storesService from "features/Stores/services/StoresService";
import { StoreSummary } from "types";
import ExpiredStoreModel from "models/store/ExpiredStoreModel";
import { StoreSummaryDateFilters } from "../../services/StoresService";
import { useOptionalFilterValues } from "hooks/useFilterContext";
import moment from "moment";
import { getDefaultStoreSummaryDateFilters } from "../../services/StoresService";

export const useStoresReconciliationSummary = (
  filters?: StoreSummaryDateFilters,
  options?: { enabled?: boolean }
) => {
  const globalFilters = useOptionalFilterValues();
  const defaultFilters = getDefaultStoreSummaryDateFilters();

  const effectiveFilters: StoreSummaryDateFilters = filters ?? (
    globalFilters.startDate && globalFilters.endDate
      ? {
        startDate: moment(globalFilters.startDate).format('YYYY-MM-DD'),
        endDate: moment(globalFilters.endDate).format('YYYY-MM-DD'),
      }
      : defaultFilters
  );

  return useQuery<StoreSummary[]>({
    queryKey: ['stores', 'reconciliationSummary', effectiveFilters.startDate, effectiveFilters.endDate],
    queryFn: () => storesService.getStoresReconciliationSummary(effectiveFilters),
    enabled: options?.enabled ?? true,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useStoresSummaryStoresOnly = (
  filters?: StoreSummaryDateFilters,
  options?: { enabled?: boolean }
) => {
  const defaultFilters = getDefaultStoreSummaryDateFilters();
  const effectiveFilters: StoreSummaryDateFilters = filters ?? defaultFilters;

  return useQuery<StoreSummary[]>({
    queryKey: ['stores', 'storesOnlySummary', effectiveFilters.startDate, effectiveFilters.endDate],
    queryFn: () => storesService.getStoresSummaryStoresOnly(effectiveFilters),
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useExpiredStores = () => {
    return useQuery<ExpiredStoreModel[]>({
        queryKey: ['stores', 'expired'],
        queryFn: () => storesService.getExpiredStores(),
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
    });
};
